/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { AttachmentUploadResponse } from './attachmentUploadResponse';

export type GenericApiResponseAttachmentUploadResponseData = AttachmentUploadResponse | null;
